<script setup>
import VDevider from "@/Shared/VDevider.vue";

import { OUTBOUND_ENUM } from "../tabs.config";
import { computed, ref } from "vue";
import VShowDemographic from "../../../../Shared/Survey/Outbound/VShowDemographic.vue";
import VShowTravel from "../../../../Shared/Survey/Outbound/VShowTravel.vue";
import VShowVacation from "../../../../Shared/Survey/Outbound/VShowVacation.vue";
import VShowExpense from "../../../../Shared/Survey/Outbound/VShowExpense.vue";
import VShowAirEntryPoint from "../../../../Shared/Survey/Outbound/VShowAirEntryPoint.vue";
import VShowFeedbacks from "../../../../Shared/Survey/Outbound/VShowFeedbacks.vue";

const props = defineProps({
    tab: Object,
    surveyFields: Object,
    answers: Object,
});

const emits = defineEmits(["onNext", "onPrev"]);
const form = ref({});

const activeComponent = computed({
    get() {
        switch (props.tab.key) {
            case OUTBOUND_ENUM.FORM_1:
                return {
                    component: VShowDemographic,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case OUTBOUND_ENUM.FORM_2:
                return {
                    component: VShowTravel,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case OUTBOUND_ENUM.FORM_3:
                return {
                    component: VShowVacation,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case OUTBOUND_ENUM.FORM_4:
                return {
                    component: VShowExpense,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case OUTBOUND_ENUM.FORM_5:
                return {
                    component: VShowAirEntryPoint,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case OUTBOUND_ENUM.FORM_6:
                return {
                    component: VShowFeedbacks,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
        }
    },
});

const handelOnNext = (data) => {
    for (let props in data) {
        form.value[props] = data[props];
    }

    console.log(form.value);
    emits("onNext", { ...form.value });
};
</script>

<template>
    <div class="row">
        <div class="col-12">
            <h5>{{ tab.title }}</h5>
            <VDevider class="mb-4" />
            <KeepAlive>
                <component
                    :is="activeComponent.component"
                    :additional="activeComponent.additional"
                    @onNext="handelOnNext"
                    @onPrev="emits('onPrev')"
                />
            </KeepAlive>
        </div>
    </div>
</template>
